<div class="banner-block">
  <div class="banner-block-main-promo">
    <a [href]="primary?.url">
      <raf-image *ngIf="primary" [fromCms]="primary.image.data.attributes" fetchPriority="high"></raf-image>
    </a>
  </div>
  <div class="banner-block-side-promo">
    <ng-container *ngIf="secondary">
      <ng-container *ngFor="let banner of secondary">
        <div class="banner-block-side-promo-item">
          <a [href]="banner.url">
            <raf-image [fromCms]="banner.image.data.attributes"></raf-image>
          </a>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>







